export const lockIcon = (
  <img className="center" src="GMM-icons/GMM-icon-lock.svg" />
);
